import {
  CarWizardState,
  CruiseWizardState,
  FlightWizardState,
  HotelWizardState,
  LOBState,
  LxWizardState,
  ThirdPartyPackageWizardState,
} from "stores/wizard/state";
import { FlightType } from "stores/wizard/state/flight/typings";

export const getShoppingGlobalMicroMessage = (lobState: LOBState) => {
  const formatDate = (tripDate: Date) => {
    return tripDate.toISOString().substring(0, 10);
  };

  let originCode = lobState.location.origin.metaData.ttla;
  let destinationCode = lobState.location.destination.metaData.ttla;
  const tripStartDate = formatDate(lobState.date.start);
  let tripEndDate = formatDate(lobState.date.end);

  const isHotelOrLx: boolean = lobState instanceof HotelWizardState || lobState instanceof LxWizardState;
  const isCruise: boolean = lobState instanceof CruiseWizardState;
  const isAllInclusivePackage = lobState instanceof ThirdPartyPackageWizardState;
  const isNotRoundTripFlight =
    lobState instanceof FlightWizardState && lobState.flightTripType !== FlightType.ROUND_TRIP;
  const isGroundTransportation: boolean =
    lobState instanceof CarWizardState &&
    lobState.groundTransportationLocationState?.location.destination.metaData.regionId !== "" &&
    lobState.groundTransportationLocationState?.location.origin.metaData.ttla !== "";

  if (isHotelOrLx) {
    originCode = "";
    destinationCode = lobState.location.destination.metaData.regionId;
  } else if (isCruise) {
    originCode = "";
    destinationCode = (lobState as CruiseWizardState).cruiseDestination;
  } else if (isNotRoundTripFlight) {
    tripEndDate = "";
  } else if (isGroundTransportation) {
    const carWizardState = lobState as CarWizardState;
    originCode = carWizardState.groundTransportationLocationState?.location.origin.metaData.ttla;
    destinationCode = carWizardState.groundTransportationLocationState?.location.destination.metaData.regionId;
  } else if (isAllInclusivePackage) {
    const allInclusiveWizardState = lobState as ThirdPartyPackageWizardState;
    originCode = allInclusiveWizardState.origin;
    destinationCode = allInclusiveWizardState.destination;
    tripEndDate = "";
  }

  const uisShoppingGlobalMicroMessage = [
    {
      schemaName: "shoppingGlobal",
      messageContent: {
        originCode,
        destinationCode,
        tripStartDate,
        tripEndDate,
      },
    },
  ];

  return uisShoppingGlobalMicroMessage;
};
